import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { isEmpty, uniq } from 'lodash'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

import { useDefaultShifts } from 'modules/shift_management/hooks/useDefaultShifts'
import { useShiftsRows } from 'modules/shift_management/hooks/useShiftsRows'
import { useTemplateWeeks } from 'modules/shift_management/hooks/useTemplateWeeks'

import DefaultShifts from './DefaultShifts'
import TemplateWeeks from './TemplateWeeks'

const ColorCode = () => {
  const [{ shiftsRows }] = useShiftsRows()
  const [templateWeeks] = useTemplateWeeks()
  const [{ defaultShifts }] = useDefaultShifts()
  const [isModalVisible, setIsModalVisible] = React.useState<boolean>(false)

  const shiftsInView = useUnsafeMemo(
    () => shiftsRows.flatMap((row) => row.shifts.shifts),
    [shiftsRows]
  )

  const defaultShiftsInView = useUnsafeMemo(() => {
    const defaultShiftIdsInView = new Set(uniq(shiftsInView.map((shift) => shift.defaultShiftId)))
    return defaultShifts.filter((defaultShift) => defaultShiftIdsInView.has(defaultShift.id))
  }, [defaultShifts, shiftsInView])

  const templateWeeksInView = useUnsafeMemo(() => {
    const templateWeeksIdsInView = new Set(uniq(shiftsInView.map((shift) => shift.templateWeekId)))
    return templateWeeks.templateWeeks.filter((templateWeek) =>
      templateWeeksIdsInView.has(templateWeek.id)
    )
  }, [shiftsInView, templateWeeks])

  const showColors = useUnsafeMemo(
    () => !isEmpty(defaultShiftsInView) || !isEmpty(templateWeeksInView),
    [defaultShiftsInView, templateWeeksInView]
  )

  return (
    <>
      {showColors && (
        <Box onClick={() => setIsModalVisible(true)} style={{ cursor: 'pointer' }}>
          <Text.Normal size="100" weight="bold">
            {i18n.t('shift_management.default_shift.colors.view_color_code')}
          </Text.Normal>
        </Box>
      )}

      {isModalVisible && (
        <Modal
          // TODO: Change for the bucket illustration when available
          illustration="brush-pencil"
          title={i18n.t('shift_management.default_shift.colors.shifts_color_code')}
          onClose={() => setIsModalVisible(false)}
        >
          <Box gap="s24">
            {!!defaultShiftsInView.length && <DefaultShifts defaultShifts={defaultShiftsInView} />}
            {!!templateWeeksInView.length && <TemplateWeeks templateWeeks={templateWeeksInView} />}
          </Box>
        </Modal>
      )}
    </>
  )
}

export default observer(ColorCode)
